<script context='module'>
  import { getContext, onMount } from 'svelte';
  import { writable } from 'svelte/store';
  
  const dismissFns = new Map();
  
  const dismiss = () => {
    for (const dismissFn of dismissFns.values()) {
      dismissFn();
    }
  };

  export const onDismiss = (fn) => {
    onMount(() => {
      const id = Symbol('Spotlight');
      dismissFns.set(id, fn);
      return () => dismissFns.delete(id);
    });
  };
  
  const SPOTLIGHT_HIGHLIGHT = Symbol('Spotlight.SPOTLIGHT_HIGHLIGHT');
  export const useSpotlightHighlight = () => getContext(SPOTLIGHT_HIGHLIGHT);
</script>

<script>
  import Provider from '../Provider';

  const highlight = writable(false);
</script>

<Provider key={SPOTLIGHT_HIGHLIGHT} value={highlight}>
  <slot />

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class='backdrop' class:highlight={$highlight} on:click={dismiss} />
</Provider>

<style lang="postcss">
  .backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    pointer-events: none;
    background: transparent;
    transition: background var(--duration--fast) var(--ease--exit);

    &.highlight {
      background: var(--color--backdrop);
      transition: background var(--duration--fast) var(--ease--entrance);
      pointer-events: auto;
    }
  }
</style>
